export default "__VITE_ASSET__7f9db83f__"